import { Checkbox } from "@material-ui/core";
import React from "react";
import translateString from "../utils/Locales";
import TextNumberInput from "./TextNumberInput";

let t = translateString;

export default class InserimentoMultiploWidget extends React.Component {
    
    constructor(props){
        super(props);

        this.state = {
            visible: false,
            lunedi: false,
            martedi: false,
            mercoledi: false,
            giovedi: false,
            venerdi: false,
            sabato: false,
            domenica: false,
            numGiorni: 0,
        }
    }

    getValues(){
        return {
            ripetizioni: this.state.numGiorni,
            giorniSettimana: [this.state.lunedi, this.state.martedi, this.state.mercoledi, this.state.giovedi, this.state.venerdi, this.state.sabato, this.state.domenica]
        }
    }

    render(){
        return (
        <div style={{ marginLeft: 5, marginBottom: 10 }}>
            <div style={{cursor: 'pointer'}}
                onClick={() => {this.setState({visible: !this.state.visible})}}
                >{t('inserimento_multiplo')}: ᐁ</div>
            <div style={{display: this.state.visible ? 'block' : 'none'}}>
                <Checkbox checked={this.state.lunedi} onClick={() => {this.setState({lunedi: !this.state.lunedi})}}/>{t('lun')}
                <Checkbox checked={this.state.martedi} onClick={() => {this.setState({martedi: !this.state.martedi})}}/>{t('mar')}
                <Checkbox checked={this.state.mercoledi} onClick={() => {this.setState({mercoledi: !this.state.mercoledi})}}/>{t('mer')}
                <Checkbox checked={this.state.giovedi} onClick={() => {this.setState({giovedi: !this.state.giovedi})}}/>{t('gio')}
                <br/>
                <Checkbox checked={this.state.venerdi} onClick={() => {this.setState({venerdi: !this.state.venerdi})}}/>{t('ven')}
                <Checkbox checked={this.state.sabato} onClick={() => {this.setState({sabato: !this.state.sabato})}}/>{t('sab')}
                <Checkbox checked={this.state.domenica} onClick={() => {this.setState({domenica: !this.state.domenica})}}/>{t('dom')}
                <br/>
     
                <TextNumberInput name={t('ripetizioni') + ":"} value={this.state.numGiorni} 
                    minValue="1"
                    onChange={(val) => 
                        this.setState({numGiorni : val}
                        )
                    }/>    

            </div>
        </div>);
    }

}